/* Velours Noir Redrop: Script */
  (function () {
    var VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var FS = [
      'precision mediump float;',
      'uniform vec2 r;uniform float t;uniform float k;',
      'float f(vec2 p){',
      '  float a=sin(p.x*1.55+p.y*.62+t*.21+1.6*sin(p.y*.85-t*.12+k));',
      '  float b=sin(p.x*2.7-p.y*1.25-t*.16+1.2*sin(p.x*.55+t*.08+k*.5));',
      '  float c=sin(p.x*5.1+p.y*2.3+t*.27+k*2.);',
      '  return a*.62+b*.3+c*.08;',
      '}',
      'void main(){',
      '  vec2 uv=gl_FragCoord.xy/r.y*6.4;',
      '  float e=.012;float h0=f(uv);',
      '  float dx=(f(uv+vec2(e,0.))-h0)/e;float dy=(f(uv+vec2(0.,e))-h0)/e;',
      '  vec3 n=normalize(vec3(-dx*.3,-dy*.3,1.));',
      '  vec3 L=normalize(vec3(-.45,.6,.65));',
      '  float df=clamp(dot(n,L),0.,1.);',
      '  vec3 H=normalize(L+vec3(0.,0.,1.));',
      '  float sp=pow(clamp(dot(n,H),0.,1.),90.);',
      '  vec3 deep=vec3(.11,.008,.022);vec3 mid=vec3(.52,.035,.085);vec3 hi=vec3(1.,.52,.56);',
      '  vec3 col=mix(deep,mid,smoothstep(.2,1.,df));',
      '  col+=hi*sp*.5;',
      '  vec2 q=gl_FragCoord.xy/r;',
      '  float v=smoothstep(1.2,.2,length((q-vec2(.5,.62))*vec2(1.,1.25)));',
      '  col*=mix(.45,1.,v);',
      '  gl_FragColor=vec4(col,1.);',
      '}'
    ].join('\n');
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function two(n) { return n < 10 ? '0' + n : String(n); }
    function utc(ms) { var d = new Date(ms); return d.getUTCFullYear() + two(d.getUTCMonth() + 1) + two(d.getUTCDate()) + 'T' + two(d.getUTCHours()) + two(d.getUTCMinutes()) + two(d.getUTCSeconds()) + 'Z'; }
    function icsEsc(t) { return String(t).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
    function fold(l) { var o = ''; while (l.length > 72) { o += l.slice(0, 72) + '\r\n '; l = l.slice(72); } return o + l; }
    function ls(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) {} return null; }
    function ss(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) {} return null; }
    function publish(name, data) {
      data = data || {};
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data); } catch (e) {}
      try { var o = { event: name }; for (var k in data) o[k] = data[k]; (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {}
    }

    function init(root) {
      if (!root || root.getAttribute('data-vnd-ready') === '1') return;
      root.setAttribute('data-vnd-ready', '1');
      var doc = root.ownerDocument;
      var preview = root.getAttribute('data-preview') === 'true';
      var fbq = root.getAttribute('data-fbq') === 'true';
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var target = Date.parse(root.getAttribute('data-drop') || '');
      var params = null;
      try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }

      /* Kampagnen-Parameter für die Zuordnung merken */
      if (params) {
        var utm = [];
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { var v = params.get(k); if (v) utm.push(k.slice(4) + '=' + v.slice(0, 60)); });
        if (utm.length) ss('vnd_utm', utm.join(' '));
      }

      /* Countdown */
      var boxes = root.querySelectorAll('[data-vnd-countdown]');
      var soons = root.querySelectorAll('[data-vnd-soon],[data-vnd-mini]');
      var tplDays = root.getAttribute('data-soon-days') || '{n}';
      var tplHours = root.getAttribute('data-soon-hours') || '{hms}';
      function tick() {
        if (isNaN(target)) return true;
        var diff = target - Date.now(), i;
        if (diff <= 0) {
          root.classList.add('vnd-is-live');
          for (i = 0; i < boxes.length; i++) boxes[i].hidden = true;
          var lives = root.querySelectorAll('[data-vnd-live]');
          for (i = 0; i < lives.length; i++) lives[i].hidden = false;
          for (i = 0; i < soons.length; i++) soons[i].textContent = root.getAttribute('data-soon-live') || '';
          return true;
        }
        var t = Math.floor(diff / 1000);
        var d = Math.floor(t / 86400), h = Math.floor((t % 86400) / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
        for (i = 0; i < boxes.length; i++) {
          boxes[i].querySelector('[data-u="d"]').textContent = d;
          boxes[i].querySelector('[data-u="h"]').textContent = two(h);
          boxes[i].querySelector('[data-u="m"]').textContent = two(m);
          boxes[i].querySelector('[data-u="s"]').textContent = two(s);
        }
        var label = d >= 2 ? tplDays.replace('{n}', d) : tplHours.replace('{hms}', two(d * 24 + h) + ':' + two(m) + ':' + two(s));
        for (i = 0; i < soons.length; i++) soons[i].textContent = label;
        return false;
      }
      if (!tick()) { var iv = setInterval(function () { if (tick()) clearInterval(iv); }, 1000); }

      /* Satin */
      function satin(cv) {
        var gl = null;
        try { gl = cv.getContext('webgl', { antialias: false, alpha: false, depth: false, stencil: false, powerPreference: 'low-power' }); } catch (e) { gl = null; }
        if (!gl) return;
        function sh(type, src) { var x = gl.createShader(type); gl.shaderSource(x, src); gl.compileShader(x); return gl.getShaderParameter(x, gl.COMPILE_STATUS) ? x : null; }
        var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
        if (!vs || !fs) return;
        var pr = gl.createProgram();
        gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
        if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
        gl.useProgram(pr);
        gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        var loc = gl.getAttribLocation(pr, 'p');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
        var uR = gl.getUniformLocation(pr, 'r'), uT = gl.getUniformLocation(pr, 't'), uK = gl.getUniformLocation(pr, 'k');
        gl.uniform1f(uK, parseFloat(cv.getAttribute('data-seed') || '0') || 0);
        var raf = 0, last = 0, t0 = performance.now(), inView = false;
        function draw(time) {
          var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
          var w = Math.max(1, Math.round(cv.clientWidth * dpr)), h = Math.max(1, Math.round(cv.clientHeight * dpr));
          if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
          gl.viewport(0, 0, w, h); gl.uniform2f(uR, w, h); gl.uniform1f(uT, time); gl.drawArrays(gl.TRIANGLES, 0, 3);
        }
        draw(8);
        if (reduce) { window.addEventListener('resize', function () { draw(8); }); return; }
        function loop(now) { raf = requestAnimationFrame(loop); if (now - last < 32) return; last = now; draw((now - t0) / 1000 + 8); }
        function start() { if (!raf && inView && !document.hidden) raf = requestAnimationFrame(loop); }
        function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { inView = es[0].isIntersecting; if (inView) start(); else stop(); }, { rootMargin: '120px' }).observe(cv);
        } else { inView = true; start(); }
        document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      }
      var cvs = root.querySelectorAll('canvas[data-vnd-satin]');
      for (var c = 0; c < cvs.length; c++) satin(cvs[c]);

      /* Leiste unten */
      var sticky = root.querySelector('[data-vnd-sticky]');
      var heroCta = root.querySelector('[data-vnd-hero-cta]');
      var heroGone = false, stopSeen = {};
      function updateSticky() {
        if (!sticky) return;
        var blocked = false;
        for (var k in stopSeen) { if (stopSeen[k]) blocked = true; }
        var on = heroGone && !blocked && ls('vnd_signed') !== '1';
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }
      if (sticky && heroCta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; updateSticky(); }).observe(heroCta);
        var stops = root.querySelectorAll('[data-vnd-sticky-stop]');
        var stopObs = new IntersectionObserver(function (es) {
          for (var i = 0; i < es.length; i++) stopSeen[es[i].target.getAttribute('data-vnd-stop-id')] = es[i].isIntersecting;
          updateSticky();
        });
        for (var j = 0; j < stops.length; j++) { stops[j].setAttribute('data-vnd-stop-id', String(j)); stopObs.observe(stops[j]); }
      }

      /* Anmeldung */
      var forms = [].slice.call(root.querySelectorAll('form.vnd-form'));
      var doneTitle = '', doneText = '';
      var lastEmail = '';
      function normTel(v) {
        var t = String(v || '').replace(/[\s\-\/().]/g, '');
        if (t.indexOf('00') === 0) t = '+' + t.slice(2);
        if (t.charAt(0) === '0') {
          if (/^06/.test(t)) t = '+43' + t.slice(1);
          else if (/^01/.test(t)) t = '+49' + t.slice(1);
          else if (/^07/.test(t)) t = '+41' + t.slice(1);
        }
        return /^\+[1-9]\d{7,14}$/.test(t) ? t : '';
      }
      function telState(mode) {
        forms.forEach(function (f) {
          var box = f.querySelector('[data-vnd-tel]'), okEl = f.querySelector('[data-vnd-tel-ok]');
          if (box) box.hidden = mode !== 'show';
          if (okEl) okEl.hidden = mode !== 'done';
        });
      }
      function telErr(f, msg) { var el = f.querySelector('[data-vnd-tel-err]'); if (!el) return; el.textContent = msg || ''; el.hidden = !msg; }
      function saveTel(f) {
        var inp = f.querySelector('[data-vnd-tel] input'), btn = f.querySelector('[data-vnd-tel-save]');
        var tel = normTel(inp && inp.value);
        telErr(f, '');
        if (!tel) { telErr(f, root.getAttribute('data-msg-tel') || ''); try { inp.focus(); } catch (x) {} return; }
        var fin = function () { if (btn) btn.disabled = false; telState('done'); publish('vn_redrop_phone', { placement: place(f) }); };
        var fail = function () { if (btn) btn.disabled = false; telErr(f, root.getAttribute('data-msg-tel-fail') || ''); };
        if (btn) btn.disabled = true;
        if (preview) { setTimeout(fin, 500); return; }
        var pk = root.getAttribute('data-pk') || '';
        if (!pk || !lastEmail || typeof window.fetch !== 'function') { fail(); return; }
        var lg = f.querySelector('[data-vnd-tel-legal]');
        var props = {
          whatsapp_optin: true,
          whatsapp_optin_at: new Date().toISOString(),
          whatsapp_optin_text: lg ? lg.textContent.replace(/\s+/g, ' ').trim() : '',
          whatsapp_optin_source: ((root.getAttribute('data-url') || window.location.pathname) + ' | ' + place(f)).slice(0, 250)
        };
        window.fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(pk), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': root.getAttribute('data-rev') || '2026-10-15' },
          body: JSON.stringify({ data: { type: 'profile', attributes: { email: lastEmail, phone_number: tel, properties: props } } })
        }).then(function (r) { if (r.status >= 200 && r.status < 300) fin(); else fail(); }).catch(fail);
      }
      function parts(f) {
        return { field: f.querySelector('.vnd-field'), legal: f.querySelector('.vnd-legal'), err: f.querySelector('[data-vnd-err]'), done: f.querySelector('[data-vnd-done]') };
      }
      function setDone(mode) {
        forms.forEach(function (f) {
          var x = parts(f);
          if (!x.done) return;
          var tt = x.done.querySelector('[data-vnd-done-title]'), tx = x.done.querySelector('[data-vnd-done-text]');
          if (!doneTitle && tt) { doneTitle = tt.textContent; doneText = tx ? tx.textContent : ''; }
          if (tt) tt.textContent = mode === 'known' ? (root.getAttribute('data-msg-known-title') || doneTitle) : doneTitle;
          if (tx) tx.textContent = mode === 'known' ? (root.getAttribute('data-msg-known-text') || doneText) : doneText;
          if (x.field) x.field.hidden = true;
          if (x.legal) x.legal.hidden = true;
          if (x.err) x.err.hidden = true;
          x.done.hidden = false;
          f.classList.add('is-done');
          f.classList.remove('is-invalid', 'is-busy');
        });
        updateSticky();
      }
      function reset() {
        ls('vnd_signed', null);
        lastEmail = '';
        telState('hide');
        forms.forEach(function (f) { var ti = f.querySelector('[data-vnd-tel] input'); if (ti) ti.value = ''; telErr(f, ''); });
        forms.forEach(function (f) {
          var x = parts(f);
          if (!x.done) return;
          if (x.field) x.field.hidden = false;
          if (x.legal) x.legal.hidden = false;
          x.done.hidden = true;
          f.classList.remove('is-done');
        });
        updateSticky();
        var first = forms[0] && forms[0].querySelector('input[type="email"]');
        if (first) { try { first.focus(); } catch (e) {} }
      }
      function showErr(f, msg) { var x = parts(f); if (!x.err) return; x.err.textContent = msg; x.err.hidden = false; f.classList.add('is-invalid'); }
      function clearErr(f) { var x = parts(f); if (x.err) { x.err.hidden = true; x.err.textContent = ''; } f.classList.remove('is-invalid'); }
      function busy(f, on) { f.classList.toggle('is-busy', on); var b = f.querySelector('button[type="submit"]'); if (b) b.disabled = on; }
      function place(f) { return (f.id || '').replace('vnd-form-', ''); }
      function success(f, em) {
        busy(f, false);
        ls('vnd_signed', '1');
        setDone('new');
        lastEmail = em;
        telState('show');
        publish('vn_redrop_lead', { placement: place(f) });
        if (fbq && typeof window.fbq === 'function') { try { window.fbq('track', 'Lead', { content_name: 'VN Redrop' }); } catch (e) {} }
        try { var utm = ss('vnd_utm'); if (utm && window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: em, vn_redrop_utm: utm }); } catch (e) {}
        var d = parts(f).done; if (d) { try { d.focus({ preventScroll: true }); } catch (e) {} }
      }
      function native(f) {
        busy(f, false);
        f.setAttribute('data-vnd-native', '1');
        try { HTMLFormElement.prototype.submit.call(f); } catch (e) { f.submit(); }
      }
      function send(f, em) {
        var pk = root.getAttribute('data-pk') || '', list = root.getAttribute('data-list') || '';
        if (!pk || !list || typeof window.fetch !== 'function') { native(f); return; }
        busy(f, true);
        var utm = ss('vnd_utm');
        var src = ((root.getAttribute('data-src') || 'Landingpage') + ' | ' + place(f) + (utm ? ' | ' + utm : '')).slice(0, 250);
        var body = { data: { type: 'subscription', attributes: { custom_source: src, profile: { data: { type: 'profile', attributes: { email: em, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
        var ctl = null, timer = 0;
        try { ctl = new AbortController(); timer = setTimeout(function () { ctl.abort(); }, 12000); } catch (e) { ctl = null; }
        window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(pk), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': root.getAttribute('data-rev') || '2026-10-15' },
          body: JSON.stringify(body),
          signal: ctl ? ctl.signal : undefined
        }).then(function (r) {
          clearTimeout(timer);
          if (r.status >= 200 && r.status < 300) { success(f, em); return; }
          publish('vn_redrop_signup_fallback', { status: r.status, placement: place(f) });
          native(f);
        }).catch(function () {
          clearTimeout(timer);
          publish('vn_redrop_signup_fallback', { status: 0, placement: place(f) });
          native(f);
        });
      }
      forms.forEach(function (f) {
        var input = f.querySelector('input[type="email"]');
        f.noValidate = true;
        f.addEventListener('submit', function (e) {
          if (f.getAttribute('data-vnd-native') === '1' || !input) return;
          if (f.classList.contains('is-done')) { e.preventDefault(); return; }
          var em = (input.value || '').trim();
          clearErr(f);
          if (!EMAIL.test(em)) { e.preventDefault(); showErr(f, root.getAttribute('data-msg-email') || ''); try { input.focus(); } catch (x) {} return; }
          e.preventDefault();
          if (preview) {
            busy(f, true);
            setTimeout(function () {
              if (/^fehler@/i.test(em)) { busy(f, false); showErr(f, 'Vorschau: So sieht der Fehlerfall aus.'); return; }
              success(f, em);
            }, 700);
            return;
          }
          send(f, em);
        });
        if (input) input.addEventListener('input', function () { clearErr(f); });
        var rs = f.querySelector('[data-vnd-reset]');
        if (rs) rs.addEventListener('click', reset);
        var tb = f.querySelector('[data-vnd-tel-save]'), ti = f.querySelector('[data-vnd-tel] input');
        if (tb) tb.addEventListener('click', function () { saveTel(f); });
        if (ti) {
          ti.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); saveTel(f); } });
          ti.addEventListener('input', function () { telErr(f, ''); });
        }
      });
      if (root.querySelector('[data-vnd-shop-ok]')) {
        if (ls('vnd_signed') !== '1') publish('vn_redrop_lead', { placement: 'shopify' });
        ls('vnd_signed', '1');
        setDone('known');
      } else if (ls('vnd_signed') === '1') {
        setDone('known');
      }
      if (params && (params.has('bestaetigt') || params.has('confirmed'))) {
        var cb = root.querySelector('[data-vnd-confirmed]');
        if (cb) cb.hidden = false;
        if (ss('vnd_confirmed_sent') !== '1') {
          ss('vnd_confirmed_sent', '1');
          publish('vn_redrop_confirmed', {});
          if (fbq && typeof window.fbq === 'function') { try { window.fbq('track', 'CompleteRegistration', { content_name: 'VN Redrop' }); } catch (e) {} }
        }
        ls('vnd_signed', '1');
        setDone('known');
      }

      /* Kalender */
      var cals = root.querySelectorAll('[data-vnd-cal]');
      if (isNaN(target)) {
        for (var ci = 0; ci < cals.length; ci++) cals[ci].hidden = true;
      } else {
        var calTitle = root.getAttribute('data-cal-title') || '';
        var calText = root.getAttribute('data-cal-text') || '';
        var pageUrl = root.getAttribute('data-url') || (window.location.origin + window.location.pathname);
        if (pageUrl.indexOf('http') !== 0) pageUrl = window.location.origin + window.location.pathname;
        var st = utc(target), en = utc(target + 3600000);
        var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//More Than Perfume//Redrop//DE', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
          'UID:' + st + '-redrop@' + (window.location.hostname || 'morethanperfume.com'), 'DTSTAMP:' + utc(Date.now()), 'DTSTART:' + st, 'DTEND:' + en,
          'SUMMARY:' + icsEsc(calTitle), 'DESCRIPTION:' + icsEsc(calText + '\n' + pageUrl), 'URL:' + pageUrl,
          'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsEsc(calTitle), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].map(fold).join('\r\n') + '\r\n';
        var icsHref = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
        var gHref = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(calTitle) + '&dates=' + st + '/' + en + '&details=' + encodeURIComponent(calText + '\n\n' + pageUrl);
        for (var cj = 0; cj < cals.length; cj++) {
          (function (box) {
            var btn = box.querySelector('[data-vnd-cal-toggle]'), menu = box.querySelector('[data-vnd-cal-menu]');
            var a1 = box.querySelector('[data-vnd-ics]'), a2 = box.querySelector('[data-vnd-gcal]');
            if (a1) a1.setAttribute('href', icsHref);
            if (a2) a2.setAttribute('href', gHref);
            if (btn && menu) btn.addEventListener('click', function () { var open = menu.hidden; menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
            [a1, a2].forEach(function (a) { if (a) a.addEventListener('click', function () { publish('vn_redrop_calendar', { type: a === a1 ? 'ics' : 'google' }); }); });
          })(cals[cj]);
        }
      }

      /* Karussell-Fortschritt */
      var rails = root.querySelectorAll('[data-vnd-rail]');
      for (var ri = 0; ri < rails.length; ri++) {
        (function (rail) {
          var bar = rail.parentNode.querySelector('[data-vnd-bar]');
          if (!bar || !bar.firstElementChild) return;
          var thumb = bar.firstElementChild;
          function upd() {
            var max = rail.scrollWidth - rail.clientWidth;
            if (max <= 2) { bar.hidden = true; return; }
            bar.hidden = false;
            var vis = rail.clientWidth / rail.scrollWidth, pos = rail.scrollLeft / max;
            thumb.style.width = (vis * 100) + '%';
            thumb.style.transform = 'translateX(' + (pos * (1 - vis) / vis * 100) + '%)';
          }
          rail.addEventListener('scroll', upd, { passive: true });
          window.addEventListener('resize', upd);
          upd();
        })(rails[ri]);
      }

      /* WhatsApp-Klicks */
      var was = root.querySelectorAll('[data-vnd-wa]');
      for (var w = 0; w < was.length; w++) was[w].addEventListener('click', function () { publish('vn_redrop_whatsapp_click', {}); });

      /* Vorschau: Links zeigen nur, was im Shop passiert, und Zustände lassen sich umschalten */
      if (preview) {
        var toast = root.querySelector('[data-vnd-toast]'), hideTimer = 0;
        var show = function (text) {
          if (!toast) return;
          toast.textContent = text; toast.hidden = false;
          clearTimeout(hideTimer);
          hideTimer = setTimeout(function () { toast.hidden = true; }, 3600);
        };
        root.addEventListener('click', function (e) {
          var a = e.target.closest ? e.target.closest('a[href]') : null;
          if (!a) return;
          var href = a.getAttribute('href') || '';
          if (href.charAt(0) === '#') return;
          e.preventDefault();
          if (a.hasAttribute('data-vnd-wa')) show('Vorschau: Hier öffnet sich WhatsApp mit der vorbereiteten Nachricht. Im Shop erst sichtbar, wenn WhatsApp eingerichtet ist.');
          else if (a.hasAttribute('data-vnd-ics')) show('Vorschau: Hier landet der Termin im Apple- oder Outlook-Kalender, mit Erinnerung 15 Minuten vorher.');
          else if (a.hasAttribute('data-vnd-gcal')) show('Vorschau: Hier öffnet sich Google Kalender mit dem fertigen Termin.');
          else show('Vorschau: Dieser Link führt im Shop zu ' + href.replace('mailto:', '') + '.');
        });
        window.VND_PREVIEW = {
          reset: reset,
          done: function () { setDone('new'); lastEmail = 'vorschau@example.com'; telState('show'); },
          known: function () { ls('vnd_signed', '1'); setDone('known'); telState('hide'); },
          error: function () { reset(); forms.forEach(function (f) { showErr(f, root.getAttribute('data-msg-email') || ''); }); },
          confirmed: function () { var b = root.querySelector('[data-vnd-confirmed]'); if (b) { b.hidden = false; b.scrollIntoView(); } ls('vnd_signed', '1'); setDone('known'); telState('hide'); },
          wa: function (on) { root.setAttribute('data-wa-hidden', on ? 'false' : 'true'); }
        };
      }
    }

    function boot() {
      var roots = document.querySelectorAll('.vnd[id^="vnd-"]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
